(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptCancelReasonDialogController', ReceiptCancelReasonDialogController);

    ReceiptCancelReasonDialogController.$inject = ['$scope', '$uibModalInstance', 'lstReceiptCancelReason', 'receipt', 'ReceiptService', '$location'];

    function ReceiptCancelReasonDialogController ($scope, $uibModalInstance, lstReceiptCancelReason, receipt, ReceiptService, $location) {
    	var cancelReasonDlgCtr = this;
    	cancelReasonDlgCtr.lstReceiptCancelReason = lstReceiptCancelReason;
    	cancelReasonDlgCtr.cancel= cancel;
    	cancelReasonDlgCtr.cancelReason = cancelReason;
    	cancelReasonDlgCtr.receipt = receipt;
    	cancelReasonDlgCtr.errorMessage = null;
    	
    	  function cancelReason() {
    		  $scope.loading = true;
    		
    		 cancelReasonDlgCtr.receipt.cancelReasonCode = cancelReasonDlgCtr.cancelReasonCode;
    		 cancelReasonDlgCtr.receipt.currentUrl = $location.absUrl().split(GLOBAL_URL)[1];
    		 ReceiptService.save({uri:"cancel-reason"},cancelReasonDlgCtr.receipt, function (result){
    			 $uibModalInstance.close(result);
    			 $scope.loading = false;
    		 }, function (error){
    			 $scope.loading = false;
    		 });  
    	    
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
